import { combineReducers } from 'redux'

import { general } from './general'
import { meetingManagement } from './meeting-management'
import { settings } from './settings'
import { meetingPage } from './meeting-page'
import { availabilities } from './availabilities'
import { onboarding } from './onboarding'
import { pagesManagement } from './pages-management'
import { languages } from './languages'

const plann3rStore = {
  general,
  meetingManagement,
  settings,
  meetingPage,
  availabilities,
  onboarding,
  pagesManagement,
  languages,
}

export default combineReducers(plann3rStore)
